import { z } from "zod";

export const addSchoolOpponentSchema = z.object({
  opponent_school_id: z.string().min(1, "Opponent school is required"),
});

export type AddSchoolOpponentInput = z.infer<typeof addSchoolOpponentSchema>;
